// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-pagination1{display:flex;justify-content:space-between;align-items:center}.el-pagination1 .text-yellow{color:#df5813!important}", ""]);
// Exports
module.exports = exports;
